// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E09L","top":"styles_top__3wV4p","left":"styles_left__3QvDt","description":"styles_description__2PlZG"};